/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Question_3Inputs */

const en_help_center__bidding_n_battles__question_3 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Question_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does "capped-player auction" mean?`)
};

/**
* | output |
* | --- |
* | "What does \"capped-player auction\" mean?" |
*
* @param {Help_Center__Bidding_N_Battles__Question_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__question_3 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Question_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Question_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__question_3(inputs)
});